import { NgModule } from '@angular/core';
import { TimeAgoComponent } from './time-ago.component';

@NgModule({
  imports: [TimeAgoComponent],
  exports: [TimeAgoComponent],
})
export class TimeAgoModule {}
